import {DocumentNode} from 'graphql';
import gql from 'graphql-tag';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import FragmentWrapper from 'graphql-client/FragmentWrapper';

import {DataFrameGraphQL} from './__generated/DataFrameGraphQL';

// All the values defined here are considered deprecated since they query for the entire dataFrameJson. New
// callers should use `BenchlingQueryForSubsetDataFrame` instead, which only queries for a subset of the
// dataFrameJson.

export const DEPRECATED_DATA_FRAME_FRAGMENT: DocumentNode = gql`
  fragment DataFrameGraphQL on DataFrameNode {
    id
    name
    dataFrameJson
    allColumnsJson
    createdAt
    creator {
      id
      name
    }
    modifiedAt
  }
`;

export const DeprecatedDataFrameFragment: FragmentWrapper<DataFrameGraphQL> = {
  fragment: DEPRECATED_DATA_FRAME_FRAGMENT,
  fragmentName: 'DataFrameGraphQL',
};

export const DEPRECATED_GET_DATA_FRAME_QUERY = gql`
  query GetDataFrame($dataFrameId: StrictString!) @skipAudit @engComponent(name: DATA_FRAMES) {
    dataFrame(id: $dataFrameId) {
      ... on DataFrameNode {
        ...DataFrameGraphQL
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${DeprecatedDataFrameFragment.fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const DEFAULT_DATA_FRAME_ROW_LIMIT = 1000;

export const GET_SUBSET_DATA_FRAME_QUERY = gql`
  query GetSubsetDataFrame($dataFrameId: StrictString!, $limit: StrictInt!)
  @skipAudit
  @engComponent(name: DATA_FRAMES) {
    dataFrame(id: $dataFrameId) {
      ... on DataFrameNode {
        id
        dataFrameJson(limitOffsetInput: {offset: 0, limit: $limit})
        allColumnsJson
        numRows
        size
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const GET_RANDOM_SUBSET_DATA_FRAME_QUERY = gql`
  query GetRandomSubsetDataFrame($dataFrameId: StrictString!, $limit: StrictInt!)
  @skipAudit
  @engComponent(name: DATA_FRAMES) {
    dataFrame(id: $dataFrameId) {
      ... on DataFrameNode {
        id
        randomSubsetDataFrameJson(limit: $limit)
        allColumnsJson
        numRows
        size
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const GET_DATA_FRAME_COLUMNS_QUERY = gql`
  query GetDataFrameColumns($dataFrameId: StrictString!) @skipAudit @engComponent(name: DATA_FRAMES) {
    dataFrame(id: $dataFrameId) {
      ... on DataFrameNode {
        id
        allColumnsJson
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
